import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { Helper } from "../helper";

export function AmountMinValidator(min: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (Helper.isEmptyInputValue(control.value) || Helper.isEmptyInputValue(min)) {
            return null; // don't validate empty values to allow optional controls
        } 

        const value = Helper.getAmountValue(control.value);
        // Controls with NaN values after parsing should be treated as not having a
        // minimum, per the HTML forms spec: https://www.w3.org/TR/html5/forms.html#attr-input-min
        return !isNaN(value) && value < min ? { AmountMinValidatorKey: { 'min': min, 'actual': control.value } } : null;
    };
}